import { Injectable } from '@angular/core';
import { GetTotalInput, DirectSearchAPIInput, SearchAPIResponse, Company, Companies } from 'models';
import { StorageService } from 'src/_services/storage.service';
import { ApiService } from 'src/_utility/api';
import { Utility } from 'utility';

@Injectable({
  providedIn: 'root'
})
export class ProductsListService {

  companies: Companies = undefined;

  constructor(
    private api: ApiService,
    private storage: StorageService
  ) { }

  loadCompanies(callback: () => void = null) {
    const storedCompanies = this.storage.getCompanies();
    if (storedCompanies) { 
      this.companies = storedCompanies;
      callback();
    }
    else {
      Utility.toPromise(this.api.getCompanies())
        .then(data => {
          this.companies = [...data];
          this.storage.setCompanies([...data]);
          callback();
        })
        .catch(err => {
          this.companies = [];
          callback();
        })
    }
  }

  getCompanies(): Companies {
    return this.companies
  }

}
